import * as React from 'react';
import Grid from '@mui/material/Grid2';
import TextFieldComponent from '../../../components/form/TextFieldComponent';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DeleteForeverIcon from '@mui/icons-material/Delete';
import EditNoteIcon from '@mui/icons-material/EditNote';
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';

interface BillableViewProps {
  handleBillableDialog: (open: boolean) => void;
  shiftStatusId: number;
  expandRowState: any[];
  billableFormItems: any[];
  inputRefs: any;
  handleArrow: (index: number) => void;
  editNoteDialog: (index: number, detailIndex: number) => void;
  handleBillableDetailChange: (
    value: any,
    index: number,
    type: any,
    detailIndex: number
  ) => void;
  removeDetailsItem: (index: number, detailIndex: number) => void;
}
const BillableView: React.FC<BillableViewProps> = ({
  shiftStatusId,
  billableFormItems,
  inputRefs,
  handleBillableDialog,
  expandRowState,
  handleArrow,
  editNoteDialog,
  handleBillableDetailChange,
  removeDetailsItem,
}) => {
  const getInputKey = (field: any, index: any) => `${field}_${index}`;
  return (
    <Grid size={12} sx={{ gap: 20, marginTop: '35px' }}>
      {(shiftStatusId === 0 || shiftStatusId === 2) && (
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          className="primarybtn"
          onClick={() => {
            handleBillableDialog(true);
          }}
        >
          Add Billable Description
        </Button>
      )}
      {billableFormItems.length > 0 && (
        <TableContainer sx={{ mt: 2 }} component={Paper}>
          <Table className="">
            {billableFormItems.map((item: any, index: any) => {
              return (
                <TableBody key={'tblbody_' + index}>
                  {index === 0 && (
                    <TableRow
                      className="headrowtbl"
                      key={'headrow_' + index}
                      style={{ background: ' rgba(0, 244, 255, 0.06)' }}
                    >
                      <TableCell
                        key={'tblheadclldesc_' + index}
                        className="boldfont"
                      >
                        Billable Description
                      </TableCell>
                      <TableCell
                        key={'tblheadcllitemc_' + index}
                        className="boldfont"
                      >
                        Resource Items
                      </TableCell>
                      <TableCell
                        key={'tblbotblheadclliqty_' + index}
                        className="boldfont"
                        style={{
                          width: '100px',
                          borderLeft: '1px solid #edeeed',
                        }}
                      >
                        Plan Quantity
                      </TableCell>
                      <TableCell
                        key={'tblbotblheadcllistarttime_' + index}
                        className="boldfont"
                        style={{ width: '' }}
                      >
                        Plan StartTime
                      </TableCell>
                      <TableCell
                        key={'tblbotblheadclliendtime_' + index}
                        className="boldfont"
                        style={{ width: '' }}
                      >
                        Plan EndTime
                      </TableCell>
                      <TableCell
                        key={'tblbotblheadclliplntotaltime_' + index}
                        className="boldfont"
                        sx={borderStyleRight}
                      >
                        Plan TotalTime
                      </TableCell>
                      <TableCell
                        key={'tblheadcllcost_' + index}
                        className="boldfont"
                        style={{ width: '150px' }}
                      >
                        Actual Quantity
                      </TableCell>
                      <TableCell
                        key={'tblheadclactstarttime_' + index}
                        className="boldfont"
                        style={{ width: '150px' }}
                      >
                        Actual Start Time
                      </TableCell>
                      <TableCell
                        key={'tblheadclactendtime_' + index}
                        className="boldfont"
                        style={{ width: '150px' }}
                      >
                        Actual Start Time
                      </TableCell>
                      <TableCell
                        key={'tblheadclacttotaltime_' + index}
                        className="boldfont"
                        style={{
                          width: '150px',
                          borderRight: '1px solid #edeeed',
                        }}
                      >
                        Actual Total Time
                      </TableCell>
                      <TableCell
                        key={'tblheadcluom_' + index}
                        className="boldfont"
                        style={{ width: '100px' }}
                      >
                        Review Quantity
                      </TableCell>
                      <TableCell
                        key={'tblbotblheadclliqtyreviewsstarttime_' + index}
                        className="boldfont"
                        style={{ width: '' }}
                      >
                        Review StartTime
                      </TableCell>
                      <TableCell
                        key={'tblbotblheadcllireviewendtime_' + index}
                        className="boldfont"
                        style={{ width: '' }}
                      >
                        Review EndTime
                      </TableCell>
                      <TableCell
                        colSpan={2}
                        key={'tblbotblheadcllireviewttltime_' + index}
                        className="boldfont"
                        style={{ width: '' }}
                      >
                        Review TotalTime
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow key={'bodyrow_' + index}>
                    {Array.from({ length: 15 }).map((_, indexCell) => (
                      <TableCell
                        key={`cell_${indexCell}`}
                        style={{
                          borderLeft:
                            indexCell === 2 ||
                            indexCell === 6 ||
                            indexCell === 10
                              ? '1px solid #edeeed'
                              : 'none', // example for borders on index 4 and 8
                        }}
                      >
                        {indexCell === 0 && (
                          <Box>
                            {expandRowState.indexOf(index) !== -1 && (
                              <KeyboardArrowDownIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  handleArrow(index);
                                }}
                              />
                            )}
                            {expandRowState.indexOf(index) === -1 && (
                              <ExpandLessIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  handleArrow(index);
                                }}
                              />
                            )}
                            {item.name}
                          </Box>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                  {item['resources'].map(
                    (detailItem: any, detailIndex: any) => {
                      return (
                        detailItem && (
                          <TableRow
                            className={
                              expandRowState.indexOf(index) !== -1
                                ? 'hidden'
                                : ''
                            }
                            key={'bodyrow_dtl_' + index + '_' + detailIndex}
                          >
                            <TableCell
                              key={
                                'bodyrow_dtl_cell_blnk-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            ></TableCell>
                            <TableCell
                              key={
                                'bodyrow_dtl_cell_name-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              {detailItem.name}
                            </TableCell>
                            <TableCell
                              sx={borderStyleLeft}
                              key={
                                'bodyrow_dtl_plan_qty-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              {shiftStatusId === 0 && detailItem && (
                                <TextFieldComponent
                                  label=""
                                  inputRef={(el: any) => {
                                    inputRefs.current[
                                      getInputKey(
                                        'planQuantity',
                                        index + '-' + detailIndex
                                      )
                                    ] = el;
                                  }}
                                  keyName={getInputKey(
                                    'planQuantity',
                                    index + '-' + detailIndex
                                  )}
                                  name={getInputKey(
                                    'planQuantity',
                                    index + '-' + detailIndex
                                  )}
                                  value={detailItem.planQuantity}
                                  onChange={(event) => {
                                    handleBillableDetailChange(
                                      event.target.value,
                                      index,
                                      'planQuantity',
                                      detailIndex
                                    );
                                  }}
                                  errorStr={''}
                                  type="number"
                                  isRequired={false}
                                  style={{ width: '120px' }}
                                />
                              )}
                              {shiftStatusId !== 0 && detailItem && (
                                <Box sx={boxStyle}>
                                  {detailItem.planQuantity}
                                </Box>
                              )}
                            </TableCell>
                            <TableCell
                              key={
                                'bodyrow_dtl_plan_startimetxt-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              {shiftStatusId === 0 && detailItem && (
                                <TextFieldComponent
                                  label=""
                                  keyName={
                                    'FormBillable_plan_start_time' + index
                                  }
                                  name={'FormBillable_plan_start_time' + index}
                                  value={detailItem.planStartTime}
                                  onChange={(event) => {
                                    handleBillableDetailChange(
                                      event.target.value,
                                      index,
                                      'planStartTime',
                                      detailIndex
                                    );
                                  }}
                                  errorStr={''}
                                  type="time"
                                  isRequired={false}
                                />
                              )}
                              {shiftStatusId !== 0 && detailItem && (
                                <Box sx={boxStyle}>
                                  {detailItem.planStartTime}
                                </Box>
                              )}
                            </TableCell>
                            <TableCell
                              key={
                                'bodyrow_dtl_plan_endimetxt-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              {shiftStatusId === 0 && detailItem && (
                                <TextFieldComponent
                                  label=""
                                  keyName={'FormBillable_plan_end_time' + index}
                                  name={'FormBillable_plan_end_time' + index}
                                  value={detailItem.planEndTime}
                                  onChange={(event) => {
                                    handleBillableDetailChange(
                                      event.target.value,
                                      index,
                                      'planEndTime',
                                      detailIndex
                                    );
                                  }}
                                  errorStr={''}
                                  type="time"
                                  isRequired={false}
                                />
                              )}
                              {shiftStatusId !== 0 && detailItem && (
                                <Box sx={boxStyle}>
                                  {detailItem.planEndTime}
                                </Box>
                              )}
                            </TableCell>
                            <TableCell
                              sx={borderStyleRight}
                              key={
                                'bodyrow_dtl_plan_total_timetxt-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              {shiftStatusId === 0 && detailItem && (
                                <Box sx={boxStyle}>
                                  {detailItem.planTotalTime}
                                  <IconButton
                                    onClick={() => {
                                      editNoteDialog(index, detailIndex);
                                    }}
                                  >
                                    <EditNoteIcon
                                      sx={{
                                        color: detailItem.notes
                                          ? '#00e5ff'
                                          : '#000',
                                      }}
                                    />
                                  </IconButton>
                                </Box>
                              )}
                              {shiftStatusId !== 0 && detailItem && (
                                <Box sx={boxStyle}>
                                  {detailItem.planTotalTime}
                                </Box>
                              )}
                            </TableCell>
                            <TableCell
                              key={
                                'bodyrow_dtl_actual_qty-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              <Box sx={boxStyle}>
                                {detailItem.actualQuantity
                                  ? detailItem.actualQuantity
                                  : '-'}
                              </Box>
                            </TableCell>
                            <TableCell
                              key={
                                'bodyrow_dtl_actaul_start-time-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              <Box sx={boxStyle}>
                                {(detailItem.actualStartTime &&
                                  detailItem.actualStartTime !== '00:00') ||
                                shiftStatusId === 2
                                  ? detailItem.actualStartTime
                                  : '-'}
                              </Box>
                            </TableCell>
                            <TableCell
                              key={
                                'bodyrow_dtl_actaul_end-time-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              <Box sx={boxStyle}>
                                {(detailItem.actualEndTime &&
                                  detailItem.actualEndTime !== '00:00') ||
                                shiftStatusId === 2
                                  ? detailItem.actualEndTime
                                  : '-'}
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={borderStyleRight}
                              key={
                                'bodyrow_dtl_actaultotal-time-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              <Box sx={boxStyle}>
                                {detailItem.actualTotalTime &&
                                detailItem.actualTotalTime != '0h'
                                  ? detailItem.actualTotalTime
                                  : '-'}
                              </Box>
                            </TableCell>
                            <TableCell
                              key={
                                'bodyrow_dtl_cell_reviewQty-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              {(shiftStatusId === 2 || shiftStatusId === 3) &&
                                detailItem && (
                                  <TextFieldComponent
                                    inputRef={(el: any) => {
                                      inputRefs.current[
                                        getInputKey(
                                          'reviewQuantity',
                                          index + '-' + detailIndex
                                        )
                                      ] = el;
                                    }}
                                    label=""
                                    keyName={
                                      'costFormBillable_review_qty_' + index
                                    }
                                    name={
                                      'costFormBillable_review_qty_' + index
                                    }
                                    value={
                                      detailItem.reviewQuantity
                                        ? detailItem.reviewQuantity
                                        : ''
                                    }
                                    onChange={(event: any) => {
                                      handleBillableDetailChange(
                                        event.target.value,
                                        index,
                                        'reviewQuantity',
                                        detailIndex
                                      );
                                    }}
                                    errorStr={''}
                                    type="number"
                                    isRequired={false}
                                    style={{ width: '120px' }}
                                  />
                                )}
                              {shiftStatusId !== 2 &&
                                shiftStatusId !== 3 &&
                                detailItem && (
                                  <Box sx={boxStyle}>
                                    {detailItem.reviewQuantity
                                      ? detailItem.reviewQuantity
                                      : '-'}
                                  </Box>
                                )}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: 'center' }}
                              key={
                                'bodyrow_dtl_review_startimetxt-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              {(shiftStatusId === 2 || shiftStatusId === 3) &&
                                detailItem && (
                                  <TextFieldComponent
                                    label=""
                                    keyName={
                                      'FormBillable_review_start_time' + index
                                    }
                                    name={
                                      'FormBillable_review_start_time' + index
                                    }
                                    value={
                                      detailItem.reviewStartTime === '00:00' &&
                                      detailItem.reviewEndTime === '00:00'
                                        ? ''
                                        : detailItem.reviewStartTime
                                    }
                                    onChange={(event) => {
                                      handleBillableDetailChange(
                                        event.target.value,
                                        index,
                                        'reviewStartTime',
                                        detailIndex
                                      );
                                    }}
                                    errorStr={''}
                                    type="time"
                                    isRequired={false}
                                  />
                                )}
                              {shiftStatusId !== 2 &&
                                shiftStatusId !== 3 &&
                                detailItem && (
                                  <Box sx={boxStyle}>
                                    {detailItem.reviewStartTime &&
                                    detailItem.reviewStartTime !== '00:00'
                                      ? detailItem.reviewStartTime
                                      : '-'}
                                  </Box>
                                )}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: 'center' }}
                              key={
                                'bodyrow_dtl_review_endimetxt-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              {(shiftStatusId === 2 || shiftStatusId === 3) &&
                                detailItem && (
                                  <TextFieldComponent
                                    label=""
                                    keyName={
                                      'FormBillable_review_end_time' + index
                                    }
                                    name={
                                      'FormBillable_review_end_time' + index
                                    }
                                    value={
                                      detailItem.reviewStartTime === '00:00' &&
                                      detailItem.reviewEndTime === '00:00'
                                        ? ''
                                        : detailItem.reviewEndTime
                                    }
                                    onChange={(event) => {
                                      handleBillableDetailChange(
                                        event.target.value,
                                        index,
                                        'reviewEndTime',
                                        detailIndex
                                      );
                                    }}
                                    errorStr={''}
                                    type="time"
                                    isRequired={false}
                                  />
                                )}
                              {shiftStatusId !== 2 &&
                                shiftStatusId !== 3 &&
                                detailItem && (
                                  <Box sx={boxStyle}>
                                    {detailItem.reviewEndTime &&
                                    detailItem.reviewEndTime !== '00:00'
                                      ? detailItem.reviewEndTime
                                      : '-'}
                                  </Box>
                                )}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: 'center' }}
                              key={
                                'bodyrow_dtl_review_totalimetxt-' +
                                index +
                                '_' +
                                detailIndex
                              }
                            >
                              <Box sx={boxStyle}>
                                {detailItem.reviewTotalTime}
                              </Box>
                            </TableCell>
                            {
                              <TableCell style={{ width: '100px' }}>
                                {((shiftStatusId === 2 &&
                                  !detailItem.shiftResourceId) ||
                                  shiftStatusId === 0) && (
                                  <IconButton
                                    key={
                                      'bodyrow_dtl_cell_delet-icn-' +
                                      index +
                                      '_' +
                                      detailIndex
                                    }
                                    aria-label="delete"
                                    onClick={() => {
                                      removeDetailsItem(index, detailIndex);
                                    }}
                                    sx={boxStyle}
                                  >
                                    <DeleteForeverIcon
                                      key={
                                        'bodyrow_dtl_cell_only-icn-' +
                                        index +
                                        '_' +
                                        detailIndex
                                      }
                                    />
                                  </IconButton>
                                )}
                                {(shiftStatusId === 2 ||
                                  shiftStatusId === 3) && (
                                  <IconButton
                                    onClick={() => {
                                      editNoteDialog(index, detailIndex);
                                    }}
                                  >
                                    <EditNoteIcon
                                      sx={{
                                        color: detailItem.notes
                                          ? '#00e5ff'
                                          : '#000',
                                      }}
                                    />
                                  </IconButton>
                                )}
                              </TableCell>
                            }
                          </TableRow>
                        )
                      );
                    }
                  )}
                </TableBody>
              );
            })}

            {/* </TableBody> */}
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
export default BillableView;
const boxStyle = {
  marginBottom: '15px',
};
const borderStyleRight = {
  borderRight: '1px solid #edeeed',
};
const borderStyleLeft = {
  borderLeft: ' 1px solid  #edeeed',
};
